<template>
  <b-container fluid>
    <b-form @submit="changePassword">
      <b-row class="my-1">
        <b-col sm="3" lg="3"></b-col>
        <b-col sm="6" lg="6">
          <img :title="$t('LNG_TITLE', this.lang)" :alt="$t('LNG_TITLE', this.lang)" width="200px" src="../assets/img/logo.jpg">
          <h2>{{ $t('LNG_CHANGE_PASSWORD', lang) }}</h2>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col sm="3" lg="4"></b-col>
        <b-col sm="6" lg="4">
           <b-input-group>       
              <b-input-group-text slot="prepend">
                 <i class="fa fa-fw fa-at"></i>
              </b-input-group-text>
              <b-form-input type="password" @keydown="setErrorMessage('')" class="form-control" v-model="newPassword" :placeholder="$t('LNG_NEW_PASSWORD', lang)" required autofocus autocapitalize="off"></b-form-input>
           </b-input-group>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col sm="3" lg="4"></b-col>
        <b-col sm="6" lg="4">
           <b-input-group>       
              <b-input-group-text slot="prepend">
                 <i class="fa fa-fw fa-at"></i>
              </b-input-group-text>
              <b-form-input type="password" @keydown="setErrorMessage('')" class="form-control" v-model="newPasswordConfirm" :placeholder="$t('LNG_NEW_PASSWORD_CONFIRM', lang)" required autocapitalize="off"></b-form-input>
           </b-input-group>
        </b-col>
      </b-row>
      <b-row class="my-3">  
        <b-col sm="2" lg="4"></b-col>
        <b-col sm="5" lg="2">
           <b-button variant="evaobj" type="submit">{{ $t('LNG_CONFIRM', lang) }}</b-button>
        </b-col>
        <b-col sm="5" lg="2">
          <b-button variant="danger" type="button" v-on:click.prevent="changePasswordCancel()">{{ $t('LNG_CANCEL', lang) }}</b-button>
        </b-col>
      </b-row>
    </b-form>
    <div>
      <br />
      <p class="text-warning">{{ this.errorMessage }}</p>
    </div>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import { focus } from 'vue-focus'

export default {
  name: 'changePassword',
  ready: function () {
    this.focus = 'newPassword'
    console.log(this.focus)
  },
  data () {
    return {
      code: '',
      counter: 0,
      errorMessage: '',
      focus: '',
      newPassword: '',
      newPasswordConfirm: '',
      oldPassword: '',
      successMessage: '',
      username: ''
    }
  },
  directives: {
    focus: focus
  },
  mounted: function () {
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    ...mapState([
      'api',
      'fullname',
      'lang'
    ])
  },
  methods: {
    setErrorMessage (errorTag = '') {
      this.errorMessage = errorTag
    },
    setSuccessMessage (successMessage = '') {
      this.successMessage = successMessage
    },
    changePassword: function () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'changePassword',
          newPassword: this.newPassword,
          newPasswordConfirm: this.newPasswordConfirm
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.newPassword = ''
        this.newPasswordConfirm = ''
        if (response.data.changed) {
          this.$router.push({ path: '/mainview' })
        } else {
          this.setErrorMessage(response.data.result.errorText)
        }
      })
      .catch(function (error) {
        this.newPassword = ''
        this.newPasswordConfirm = ''
        console.log(error)
      })
    },
    changePasswordCancel: function () {
      if (this.needPasswordChange) {
        this.$store.commit('LOGOUT')
        this.$router.push({ path: '/' })
      } else {
        this.$router.push({ path: '/mainview' })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.login {
  margin-top: 50px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// ChangePassword.vue?e14a3018